import { Component } from '@angular/core';
import { ContentComponent } from '../../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../../common/breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'app-privacy-statement-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent
  ],
  templateUrl: './privacy-statement-page.component.html'
})
export class PrivacyStatementPageComponent {

}
